export const getOrdersIdsLabel = (ordersIds: string[]) =>
   ordersIds.reduce(
      (ordersIdsResultLabel, currentOrderId, currentIndex, array) =>
         currentIndex !== array.length - 1
            ? `${ordersIdsResultLabel}#${currentOrderId}, `
            : `${ordersIdsResultLabel}#${currentOrderId}`,
      'nr ',
   );
